import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const Footer = () => {
    return (
        <>
            <footer>
                <div className="footer max-w-full mx-auto px-4 sm:px-6 bg-black-100 border-t border-b py-30">

                    {/* Top area: Blocks */}
                    <div className="grid sm:grid-cols-12 gap-5 py-8 md:py-12 border-t border-black lg:ml-11">

                        {/* 1st block */}
                        <div className="col-span-12 lg:col-span-4">
                            <div className="box-border border-b-4 border-black p-8 bg-gray-200 text-gray-600 text-center rounded-lg xl:w-80 mx-auto">
                                <h3 className="font-bold text-4xl mb-4">Trucxo</h3>
                                <div className='text-md font-medium text-gray-600'>
                                    <p>Darlaghat</p>
                                    <p>Himachal Pradesh</p>
                                </div>
                            </div>
                        </div>

                        {/* 2nd block */}
                        <div className="col-span-6 md:col-span-6 lg:col-span-1 ml-7 mx-auto">
                            <h6 className="text-[#000000] text-xl font-bold mb-4">LINKS</h6>
                            <ul className="text-md">
                                <li className="mb-2">
                                    <HashLink to="/contact" className="text-[#000000] hover:text-black hover:tracking-wider transition duration-250 ease-in-out">Contact</HashLink>
                                </li>
                                <li className="mb-2">
                                    <Link to="/privacy-policy" className="text-[#000000] hover:text-black">Privacy Policy</Link>
                                </li>
                                <li className="mb-2">
                                    <Link to="/refund-policy" className="text-[#000000] hover:text-black">Refund Policy</Link>
                                </li>
                                <li className="mb-2">
                                    <Link to="/terms-and-conditions" className="text-[#000000] hover:text-black">Terms & Conditions</Link>
                                </li>
                                <li className="mb-2">
                                    <Link to="/shipping-policy" className="text-[#000000] hover:text-black">Shipping Policy</Link>
                                </li>
                            </ul>
                            <div className="mt-6 text-md">
    <h6 className="text-[#000000] text-xl font-bold mb-2">Grievance Officer</h6>
    <p className="text-black">
      Email: <a href="mailto:operations@trucxo.com" className="text-blue-600 underline hover:text-blue-800">operations@trucxo.com</a><br />
      Response Time: Within 5 business days
    </p>
  </div>
                        </div>

                        {/* 3rd block */}
                        <div className="col-span-6 md:col-span-6 lg:col-span-4 mx-auto">
                            <h6 className="text-[#000000] text-xl font-bold mb-4">OUR SERVICES</h6>
                            <ul className="text-md">
                                <li className="mb-2">
                                    <Link to="#" className="text-[#000000] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Seamless Load Matching</Link>
                                </li>
                                <li className="mb-2">
                                    <Link to="#" className="text-[#000000] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Real-Time Tracking</Link>
                                </li>
                                <li className="mb-2">
                                    <Link to="#" className="text-[#000000] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Cost Optimization</Link>
                                </li>
                                <li className="mb-2">
                                    <Link to="#" className="text-[#000000] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Simplified Communication</Link>
                                </li>
                            </ul>
                        </div>

                        {/* 4th block */}
                        <div className="col-span-12 text-center mx-auto lg:col-span-3 font-bold uppercase text-black-900">
                            <div className="text-xl mb-6">
                                Social Media Links.
                            </div>

                            <div className="text-md font-medium mb-6">
                                Follow us on social media.
                            </div>
                            <div className="mx-auto text-center mt-2">
                                <ul className="flex justify-center mb-4 md:mb-0">
                                    <li>
                                        <a href="https://www.linkedin.com/in/trucxo-company-a61912348/" target="_blank" rel="noreferrer" className="rounded-full flex hover:bg-white-100 justify-center bg-white h-8 text-black  w-8  mx-1 text-center pt-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className='fill-current font-black hover:animate-pulse'><circle cx="4.983" cy="5.009" r="2.188"></circle><path d="M9.237 8.855v12.139h3.769v-6.003c0-1.584.298-3.118 2.262-3.118 1.937 0 1.961 1.811 1.961 3.218v5.904H21v-6.657c0-3.27-.704-5.783-4.526-5.783-1.835 0-3.065 1.007-3.568 1.96h-.051v-1.66H9.237zm-6.142 0H6.87v12.139H3.095z"></path></svg>
                                        </a>
                                    </li>
                                    {/* <li className="ml-4">
                                        <Link to="#" className="flex justify-center items-center text-black hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out" aria-label="Facebook">
                                        <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.023 24L14 17h-3v-3h3v-2c0-2.7 1.672-4 4.08-4 1.153 0 2.144.086 2.433.124v2.821h-1.67c-1.31 0-1.563.623-1.563 1.536V14H21l-1 3h-2.72v7h-3.257z" />
                                        </svg>
                                        </Link>
                                    </li> */}
                                </ul>
                            </div>
                        </div>

                    </div>


                </div>

            </footer>
        </>
    )
}
export default Footer;
